import React, {  Component } from 'react';

export default class ProductStatusDescriptionsOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('ProductStatusDescriptionsOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="actionDescriptionsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
				<a className="closeButton fontSize-10" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Product Status Descriptions</h2>
                    <div className="scroll-height-action-description">
    					<table className="dataTable actionDescriptionsTable">
    						<thead>
    							<tr>
    								<th>Status&nbsp;Name</th>
    								<th>Status Description</th>
    							</tr>
    						</thead>
    						<tbody>
    							<tr>
    								<td>On Hand</td>
    								<td>Product is on hand in the ADC. It is not reserved either due to a process that needs to run or because it is a dated order.</td>
    							</tr>
                                <tr>
    								<td>In Transit</td>
    								<td>Product is in transit to the ADC to fill this order.</td>
    							</tr>
                                <tr>
    								<td>Sched Prod</td>
    								<td>Production is scheduled in the factory to fill this order.</td>
    							</tr>
                                <tr>
    								<td>Prod TBD</td>
    								<td>The system estimates this is the date that the product will be available, but no product has been produced or scheduled yet.These would have been N/A in the legacy system.</td>
    							</tr>
                                <tr>
    								<td>Expires</td>
    								<td>This will show for an Available Backorder.  In the Expected Available column you will see the date that this backorder will expire.</td>
    							</tr>
                                <tr>
    								<td>FP</td>
    								<td>When the Expected Available Date shows FP, this model has passed its final production date and there is no product in the supply chain to fulfill this order.</td>
    							</tr>
                                <tr>
    								<td>NA</td>
    								<td>When the Expected Available Date shows NA, the system cannot estimate an availability date.  This model likely has limited production scheduled.</td>
    							</tr>
    						</tbody>
    					</table>
                    </div>
            	</div>
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/productStatusDescriptionsOverlayDialog.js